import { IContext } from "@src/context";
import { resolveUrl } from "@src/utils/baseUrl";
import { isFavorite } from "@src/utils/favorite";
import { IProperty } from "./types";
import messages, { propertyItemMessages, unitStatusMessages } from "./messages";

function isAvaiable({ fps }: IProperty): boolean {
  return (
    fps?.find((floorPlan) => floorPlan?.vac != null && floorPlan.vac > 0) !=
    null
  );
}

export function renderSlides(
  context: IContext,
  properties: IProperty[]
): string[] {
  const { intl } = context;
  return properties.map((property) => {
    return `<div class="swiper-slide">
    <div class="container-featured-properties-item">
      <div class="container-featured-properties-item-left">
        <div class="container-featured-properties-item-info">
          <div class="container-featured-properties-item-image">
            <picture>
            ${
              property.img?.webp != null
                ? `<source type="image/webp" data-srcset="${resolveUrl(
                    property.img.webp
                  )}"></source>`
                : ""
            }
            <img
              class="lazyload"
              data-src="${
                property.img?.orig != null
                  ? resolveUrl(property.img.orig)
                  : resolveUrl("/static/images/default.jpg")
              }"
              alt="${intl.formatMessage(messages.name, {
                name: property.name,
              })}"
            ></img>
          </picture>
            <div
              class="container-featured-properties-item-favorite"
              data-favorite="${isFavorite(
                property.id?.toString() || ""
              ).toString()}"
              data-property-id="${property.id?.toString() || ""}"
            ></div>
          </div>
          <div class="container-featured-properties-item-name">${intl.formatMessage(
            messages.name,
            {
              name: property.name,
            }
          )}</div>
          <div
            class="container-featured-properties-item-address element-address"
          >
            <span>${property.addr}</span>
          </div>
        </div>
        <div class="container-featured-properties-item-property">
          <div class="element-unit-status">
            ${
              property.feats?.elev
                ? `<dl>
                    <dt data-type="elevator"></dt>
                    <dd>${intl.formatMessage(unitStatusMessages.elevator)}</dd>
                  </dl>`
                : ""
            }
            ${
              property.feats?.pet
                ? `<dl>
                    <dt data-type="petFriendly"></dt>
                    <dd>${intl.formatMessage(unitStatusMessages.pet)}</dd>
                  </dl>`
                : ""
            }
            ${
              property.feats?.pk
                ? `<dl>
                    <dt data-type="parking"></dt>
                    <dd>${intl.formatMessage(unitStatusMessages.parking)}</dd>
                  </dl>`
                : ""
            }
          </div>
          <div class="container-featured-properties-item-status" data-status="${
            isAvaiable(property) ? "available" : "coming-soon"
          }">
            <span>${intl.formatMessage(propertyItemMessages.availableNote, {
              isAvailable: isAvaiable(property),
            })}</span>
          </div>
        </div>
      </div>
      <div class="container-featured-properties-item-right">
        <div class="container-featured-properties-item-rooms">
          <ul class="container-featured-properties-item-rooms-inner">
            ${(property.fps ?? [])
              .filter((item) => Number(item.vac) > 0)
              .map(
                (floorPlan) =>
                  `<li>
                  <a href="${
                    property.detailLink != null && floorPlan.lType != null
                      ? `${property.detailLink}#${floorPlan.lType}`
                      : ""
                  }" target="_blank">
                    ${
                      floorPlan.lType != null && floorPlan.size != null
                        ? `<strong>
                          ${intl.formatMessage(
                            propertyItemMessages.floorPlanTitle,
                            {
                              lType: floorPlan.lType,
                              size: floorPlan.size,
                            }
                          )}
                        </strong>`
                        : ""
                    }
                    ${
                      floorPlan.minRent != null && floorPlan.minRent > 0
                        ? `<span>
                        ${intl.formatMessage(
                          propertyItemMessages.floorPlanDescription,
                          {
                            minRent: floorPlan.minRent,
                          }
                        )}
                      </span>`
                        : ""
                    }
                  </a>
                </li>`
              )
              .join("")}
          </ul>
        </div>
        <a
          class="container-featured-properties-item-button"
          href="${property.detailLink || ""}"
          target="_blank"
        >
          <span>${intl.formatMessage(messages.detailButton)}</span>
        </a>
      </div>
    </div>
  </div>`;
  });
}
